import { QueryOptions } from '@shared/fetch-utils';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';
import { useMPEFetch } from '@retail/app/hooks';
import { AssortmentWithCountDTO, CentralAssortmentItemDTO } from '@retail/my-assortment/types';

interface Props extends QueryOptions {
  assortmentId: number;
  inAssortment?: boolean;
  supplierNumber?: number;
  groupNumbers?: string[];
  query?: string;
  fromDate?: string | null;
  toDate?: string | null;
  tagFilter?: 'ALL' | 'TAGGED' | 'UNTAGGED';
  tagIds?: number[];
  filterExpiredTags?: boolean;
}

export function useFetchCentralAssortmentMemberView({
  assortmentId,
  inAssortment,
  supplierNumber,
  groupNumbers,
  fromDate,
  toDate,
  tagIds,
  query,
  ...queryOptions
}: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<AssortmentWithCountDTO<CentralAssortmentItemDTO>>({
    method: 'GET',
    queryKey: [
      'central-assortments-member-view',
      assortmentId,
      inAssortment,
      supplierNumber,
      groupNumbers,
      tagIds,
      fromDate,
      toDate,
      query,
    ],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.assortments.assortment.centralAssortments.getFullLinkPath({ assortmentId }),
      searchParams: { inAssortment, supplierNumber, groupNumbers, fromDate, toDate, tagIds, query },
    }),
    ...queryOptions,
  });
}

export function useFetchCentralAssortment({
  assortmentId,
  supplierNumber,
  groupNumbers,
  fromDate,
  toDate,
  query,
  tagIds,
  tagFilter,
  filterExpiredTags,
  ...queryOptions
}: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<AssortmentWithCountDTO<CentralAssortmentItemDTO>>({
    method: 'GET',
    queryKey: [
      'central-assortments',
      assortmentId,
      supplierNumber,
      groupNumbers,
      fromDate,
      toDate,
      query,
      tagIds,
      tagFilter,
      filterExpiredTags,
    ],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.brandAssortments.assortment.items.getFullLinkPath({ assortmentId }),
      searchParams: {
        supplierNumber,
        groupNumbers,
        query,
        fromDate,
        toDate,
        tagIds,
        tagFilter,
        filterExpiredTags,
      },
    }),
    ...queryOptions,
  });
}
